import React from "react";
import { motion } from "framer-motion";
import "./HRPlatformSection.css";

import hrImg from "../../../assets/images/hr1.png";
import attendanceImg from "../../../assets/images/team.webp";
import payrollImg from "../../../assets/images/payroll-mgmt.webp";

const sections = [
  {
    title: "HR MANAGEMENT SIMPLIFIED",
    desc: `Adapt to new realities, work faster and smarter. Determine a defined future of work for your organization with a strong, flexible, global HR solution.`,
    points: [
      "Easy access to documents and information",
      "An employee database that scales",
      "Smart HR workflows",
      "Automation of HR processes",
    ],
    img: hrImg,
  },
  {
    title: "TIME AND ATTENDANCE",
    desc: `Unlock higher productivity through our advanced time and attendance system and create a seamless onboarding experience that accelerates employee success.`,
    points: [
      "Enhanced employee accountability",
      "Accurate payroll processing",
      "Flexible attendance recording",
      "Transparent attendance policies",
    ],
    img: attendanceImg,
  },
  {
    title: "PAYROLL MANAGEMENT",
    desc: `Simplify complex payroll operations with a secure, automated and fully compliant payroll management system ensuring accurate and timely payouts.`,
    points: [
      "Accurate payroll calculations & deductions",
      "Generate compliant payslips",
      "Plan future payroll costs",
      "Secure data & privacy protection",
    ],
    img: payrollImg,
  },
];

const HRPlatformSection = () => {
  return (
    <section className="hrps-wrapper">
      {/* Heading */}
      

      {/* Sections */}
      {sections.map((item, index) => (
        <motion.div
          key={index}
          className={`hrps-section ${
            index % 2 !== 0 ? "reverse" : ""
          }`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Content */}
          <div className="hrps-content">
            <h3>{item.title}</h3>
            <p className="hrps-desc">{item.desc}</p>

            <ul className="hrps-list">
              {item.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="hrps-image">
            <img src={item.img} alt={item.title} />
          </div>
        </motion.div>
      ))}
    </section>
  );
};

export default HRPlatformSection;
